var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99486 3.2337C7.49535 1.48064 4.99481 1.00907 3.11602 2.61435C1.23723 4.21962 0.972726 6.90357 2.44815 8.80214C3.56257 10.2362 6.72847 13.1151 8.21101 14.438C8.48354 14.6812 8.61981 14.8028 8.77937 14.8507C8.9179 14.8922 9.07183 14.8922 9.21036 14.8507C9.36992 14.8028 9.50619 14.6812 9.77872 14.438C11.2613 13.1151 14.4272 10.2362 15.5416 8.80214C17.017 6.90357 16.7848 4.20274 14.8737 2.61435C12.9626 1.02595 10.4944 1.48064 8.99486 3.2337Z",
    fill: "#0D3355"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 7.63184L8.25 9.13184L11.625 5.75684M8.99486 3.2337C7.49535 1.48064 4.99481 1.00907 3.11602 2.61435C1.23723 4.21962 0.972726 6.90357 2.44815 8.80214C3.56257 10.2362 6.72847 13.1151 8.21101 14.438C8.48354 14.6812 8.61981 14.8028 8.77937 14.8507C8.9179 14.8922 9.07183 14.8922 9.21036 14.8507C9.36992 14.8028 9.50619 14.6812 9.77872 14.438C11.2613 13.1151 14.4272 10.2362 15.5416 8.80214C17.017 6.90357 16.7848 4.20274 14.8737 2.61435C12.9626 1.02595 10.4944 1.48064 8.99486 3.2337Z",
    stroke: "#F8D144",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckHeart);
export default __webpack_public_path__ + "static/media/check-heart.90960a95.svg";
export { ForwardRef as ReactComponent };